import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'

export default props => {
  const query = useStaticQuery(
    graphql`
      query {
        post_1: file(relativePath: { eq: "blog/post_1.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_2: file(relativePath: { eq: "blog/post_2.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_2_1: file(relativePath: { eq: "blog/post_2_1.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_3_0: file(relativePath: { eq: "blog/post_3_0.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_3_1: file(relativePath: { eq: "blog/post_3_1.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_3_2: file(relativePath: { eq: "blog/post_3_2.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_3_3: file(relativePath: { eq: "blog/post_3_3.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_3_4: file(relativePath: { eq: "blog/post_3_4.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_3_5: file(relativePath: { eq: "blog/post_3_5.png" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_4_0: file(relativePath: { eq: "blog/post_4_0.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
        post_5_0: file(relativePath: { eq: "blog/post_5_0_moscow.jpg" }) {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  return (
    <Img
      fluid={query[props.image].childImageSharp.fluid}
      alt={props.alt}
      imgStyle={{ objectFit: 'fill' }}
    />
  )
}
